import { render, staticRenderFns } from "./EditThrill.vue?vue&type=template&id=630d2313&"
import script from "./EditThrill.vue?vue&type=script&lang=js&"
export * from "./EditThrill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports